import { render, staticRenderFns } from "./stepControl.vue?vue&type=template&id=704c560a&scoped=true"
import script from "./stepControl.vue?vue&type=script&lang=js"
export * from "./stepControl.vue?vue&type=script&lang=js"
import style0 from "./stepControl.vue?vue&type=style&index=0&id=704c560a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c560a",
  null
  
)

export default component.exports